const ActionTypes = {
    TOUR_LOADED: 'TOUR_LOADED',
    IMAGE_QUALITY_LOADED: 'IMAGE_QUALITY',
    IMPROVED_SPHERE_IMAGE: 'IMPROVED_SPHERE_IMAGE',
    SPHERE_LOADED: 'SPHERE_LOADED',
    SELECT_GROUP: 'SELECT_GROUP',
    LOAD_SPHERE: 'LOAD_SPHERE',
    SPHERE_FAILED: 'SPHERE_FAILED',
    HOTSPOT_DISPLAYED: 'HOTSPOT_DISPLAYED',
    SET_HOTSPOTS: 'SET_HOTSPOTS',
    CLEAR_HOTSPOTS: 'CLEAR_HOTSPOTS'
};

export default ActionTypes;
